import {
  MOLE_COMPANY_CODE,
  MOLE_DOMAINS,
} from "constants/moduleConstants/contract.constant";
import getDomain from "utils/getDomain";

const getContractCompanyCode = () => {
  const domain = getDomain().toLowerCase();
  return MOLE_DOMAINS.includes(domain) ? MOLE_COMPANY_CODE : domain;
};

export default getContractCompanyCode;
